import React, { useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { NavLink } from 'react-router-dom';
import { AppBar, Box } from '@mui/material';
import { Body } from '../../../landingComponents/typography';
import { ReactComponent as LametriLogo } from '../../../../assets/img/LametriLogo.svg';
import styles from './header.module.scss';
import HeaderInfo from './headerInfo';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { getClassName } from 'src/Core/utility/jsx';
// import CssBaseline from '@mui/material/CssBaseline';

const navContent = [
  { link: 'about', title: 'О проекте' },
  { link: 'howto', title: 'Инструкция' },
  { link: 'questions', title: 'Анализ' },
  { link: 'orderRequest', title: 'Результаты запросов' },
];

const drawerWidth = 240;

export default function LandingHeader({}) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container = window.document.body;

  const drawer = (
    <nav>
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Logo />
        </Box>
        <Divider />
        <List>
          {navContent.map((item) => (
            <NavItem key={item.link} {...item} />
          ))}
        </List>
      </Box>
    </nav>
  );

  return (
    <>
      <ElevationScroll>
        <AppBar
          className={styles.appHeader}
          component="header"
          sx={{
            // background: 'none',
            background: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(5px)',
          }}
        >
          <nav>
            <Box
              sx={{
                display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' },
                width: '100%',
              }}
            >
              <HeaderInfo></HeaderInfo>
            </Box>
            <Box
              sx={{
                display: 'flex',
                padding: { xs: '6px 20px', md: '6px 50px' },
                justifyContent: 'space-between',
              }}
            >
              <List sx={{ display: 'flex', alignItems: 'center' }}>
                <Logo />
                <Box
                  sx={{ display: { xs: 'none', md: 'block' }, width: '90px' }}
                ></Box>
                <Box
                  sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                  }}
                >
                  {navContent.map((i) => {
                    return <NavItem key={i.link} {...i} />;
                  })}
                </Box>
              </List>
              <Box
                sx={{
                  color: '#626264',
                  display: { xs: 'flex', sm: 'flex', md: 'none' },
                  alignItems: 'center',
                }}
              >
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  // edge="start"
                  onClick={handleDrawerToggle}
                  // sx={{ mr: 2, display: { sm: 'none' } }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            </Box>
          </nav>
        </AppBar>
      </ElevationScroll>

      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'block', md: 'block', lg: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export const NavItem = ({ link, title, textClassName, textColor }) => {
  return (
    <ListItem disablePadding onClick={null}>
      <ListItemButton
        sx={{
          borderRadius: '20px',
          '&.active': {
            textDecoration: 'underline',
            color: textColor ?? '#6d7578',
          },
        }}
        component={NavLink}
        onClick={null}
        to={`/${link}`}
      >
        <ListItemText
          primary={
            <Body className={getClassName([styles.navItemText, textClassName])}>
              {title}
            </Body>
          }
          sx={{ whiteSpace: 'nowrap' }}
        />
      </ListItemButton>
    </ListItem>
  );
};

const Logo = () => {
  return (
    <div className={styles.logo}>
      <ListItemButton
        sx={{
          borderRadius: '20px',
          // '&.MuiListItemButton-root': {
          //   marginTop: '-10px',
          // },
        }}
        component={NavLink}
        onClick={null}
        to={`/`}
      >
        <LametriLogo alt="Ламетри" />
      </ListItemButton>
    </div>
  );
};

function ElevationScroll(props) {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return children
    ? React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
      })
    : null;
}
